import { Helper } from '../../../js/util/helper';
require( 'arrive' );

const IBAN = require( 'iban' );
const BIC = require( 'bic' );

export default class Form {
  constructor( node ) {
    this.node = node;
    this.inputTexts = this.node.querySelectorAll( '.form-input' );
    this.inputSelect = this.node.querySelectorAll( '.form-select' );
    this.inputDate = this.node.querySelectorAll( '.form-date' );
    this.inputRadio = this.node.querySelectorAll( '.form-radio' );
    this.radioContainer = this.node.querySelector( '.radios--wrapper' );
    this.inputSelectReplace = this.node.querySelectorAll( '.form-item-select--replace' );
    this.checkBoxes = this.node.querySelectorAll( '.form-checkbox' );
    this.textareas = this.node.querySelectorAll( '.form-textarea' );
    this.uploads = this.node.querySelectorAll( '.js-form-type-webform-document-file' );
    this.submit = this.node.querySelector( '.form-submit-button' );
    this.tooltips = this.node.querySelectorAll( '.webform-element-help' );

    //this.disableDateInputs();
    this.handleInput();
    this.handleSelectInput( this.inputSelect, this.inputSelectReplace );
    this.handleNewSelectFields();

    window.onload = () => {
      this.inputTexts.forEach( function( input ) {
        input.setCustomValidity( '' );
        this.handleLabel( input );
      }.bind( this ));
      this.textareas.forEach( function( input ) {
        input.setCustomValidity( '' );
        this.handleLabel( input );
      }.bind( this ));
      this.inputSelect.forEach( function( input ) {
        input.setCustomValidity( '' );
        this.handleLabel( input );
      }.bind( this ));
    };

    window.addEventListener( 'click', ( e ) => {
      let containers = this.node.querySelectorAll( '.form-item-select--replace--active' );
      let wrapper = Helper.getClosest( e.target, '.form-item-select--replace--active' );

      if ( wrapper !== null && containers.length > 1 ) {
        for ( let container of containers ) {
          if ( container !== wrapper ) {
            container.click();
            let activeLink = container.parentNode.querySelector( '.form-item--option-item-active' );
            if ( activeLink !== null ) {
              activeLink.classList.remove( 'form-item--option-item-active' );
            }
          }
        }
      } else if ( wrapper === null && containers.length > 0 && !e.target.classList.contains( 'form-item-select--replace' )) {
        containers[ 0 ].click();
      }
    });

    let count = 0;
    let typedLetter = '';
    document.onkeydown = function( e ) {
      let customSelect = this.node.querySelector( '.form-item--options-active' );

      if ( customSelect !== null ) {
        let items = customSelect.querySelectorAll( 'LI' );
        let activeItems = customSelect.querySelector( '.form-item--option-item-active' );

        if ( activeItems === null && e.keyCode === 40 ) {
          if ( count >= items.length ) {
            count = 0;
          }
          items[ count ].classList.add( 'form-item--option-item-active' );
          count = count + 1;
        } else if ( activeItems !== null && e.keyCode === 40 ) {
          e.preventDefault();
          if ( count > items.length - 1 ) {
            items[ count - 1 ].classList.remove( 'form-item--option-item-active' );
            count = 0;
            items[ count ].classList.add( 'form-item--option-item-active' );
            customSelect.children[ 1 ].scrollTo({ top: count * 51, behavior: 'smooth' });
            count = count + 1;
          } else if ( count === 0 ) {
            count = 1;
            items[ count - 1 ].classList.remove( 'form-item--option-item-active' );
            items[ count ].classList.add( 'form-item--option-item-active' );
            customSelect.children[ 1 ].scrollTo({ top: count * 51, behavior: 'smooth' });
            count = count + 1;
          } else {
            items[ count - 1 ].classList.remove( 'form-item--option-item-active' );
            items[ count ].classList.add( 'form-item--option-item-active' );
            if ( count > 6 ) {
              customSelect.children[ 1 ].scrollTo({ top: ( count - 7 ) * 51, behavior: 'smooth' });
            }
            count = count + 1;
          }
        } else if ( e.keyCode === 38 ) {
          e.preventDefault();
          if (( count - 1 ) < 0 ) {
            items[ 0 ].classList.remove( 'form-item--option-item-active' );
            count = items.length - 1;
            items[ count ].classList.add( 'form-item--option-item-active' );
            customSelect.children[ 1 ].scrollTo({ top: ( count - 7 ) * 51, behavior: 'smooth' });
          } else if ( count > items.length - 1 ) {
            count = items.length - 1;
            items[ count ].classList.remove( 'form-item--option-item-active' );
            count = count - 1;
            items[ count ].classList.add( 'form-item--option-item-active' );
            customSelect.children[ 1 ].scrollTo({ top: ( count - 7 ) * 51, behavior: 'smooth' });
          } else {
            items[ count ].classList.remove( 'form-item--option-item-active' );
            count = count - 1;
            items[ count ].classList.add( 'form-item--option-item-active' );
            customSelect.children[ 1 ].scrollTo({ top: ( count - 7 ) * 51, behavior: 'smooth' });
          }
        } else if ( activeItems !== null && ( e.keyCode === 32 || e.keyCode === 13 )) {
          activeItems.click();
          activeItems.classList.remove( 'form-item--option-item-active' );
        } else if (( e.keyCode >= 65 && e.keyCode <= 90 ) || e.keyCode === 222 || e.keyCode === 219 || e.keyCode === 186 ) {
          let letter = String.fromCharCode( e.keyCode );

          for ( let item in items ) {
            if ( typeof items[ item ] === 'number' ) {
              break;
            } else if ( items[ item ].children[ 0 ].innerHTML.charAt( 0 ) === letter ) {
              item = parseInt( item );
              let active = items[ item ].parentNode.querySelector( '.form-item--option-item-active' );
              if ( active !== null && letter !== typedLetter ) {
                active.classList.remove( 'form-item--option-item-active' );
                items[ item ].classList.add( 'form-item--option-item-active' );
                customSelect.children[ 1 ].scrollTo({ top: ( item - 7 ) * 51, behavior: 'smooth' });
                count = item;
                typedLetter = letter;
                break;
              } else if ( active !== null && letter === typedLetter && items.length > item + 1 ) {
                if ( items[ item + 1 ].children[ 0 ].innerHTML.charAt( 0 ) === letter && items[ item ].classList.contains( 'form-item--option-item-active' )) {
                  active.classList.remove( 'form-item--option-item-active' );
                  items[ item + 1 ].classList.add( 'form-item--option-item-active' );
                  customSelect.children[ 1 ].scrollTo({ top: ( item - 6 ) * 51, behavior: 'smooth' });
                  count = parseInt( item + 1 );
                  typedLetter = letter;
                  break;
                }
              } else {
                items[ item ].classList.add( 'form-item--option-item-active' );
                customSelect.children[ 1 ].scrollTo({ top: ( item - 7 ) * 51, behavior: 'smooth' });
                count = item;
                typedLetter = letter;
                break;
              }
            }
          }
        }
      }
    }.bind( this );
  }
  disableDateInputs() {
    [ ...this.node.querySelectorAll( '.js-form-type-date input' ) ].forEach(( input ) => {
      input.setAttribute( 'readonly', 'readonly' );
    });
  }
  handleSelectInput( select, replace ) {
    select.forEach( function( input ) {
      input.setCustomValidity( '' );
      input.onchange = function() {
        this.handleLabel( input );
        if ( input.validity.valid && input.classList.contains( 'form-select--invalid' )) {
          input.classList.remove( 'form-select--invalid' );
          let valid = this.checkForInvalid();
          if ( valid === null ) {
            if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
              this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
            }
          }
        }
      }.bind( this );
      input.addEventListener( 'input', () => {
        this.handleLabel( input );
      });
      input.addEventListener( 'invalid', ( e ) => {
        e.preventDefault();
      });
    }.bind( this ));

    replace.forEach( function( input ) {
      let temp = input.nextSibling.nextSibling;
      let buttons = temp.getElementsByTagName( 'LI' );


      input.addEventListener( 'click', () => {
        input.classList.toggle( 'form-item-select--replace--active' );
        input.parentNode.classList.toggle( 'form-item--options-active' );
        let activeLink = input.parentNode.querySelector( '.form-item--option-item-active' );
        if ( activeLink !== null ) {
          activeLink.classList.remove( 'form-item--option-item-active' );
        }
        let label = Helper.getClosest( input, '.js-form-item' ).querySelector( 'label' );

        if ( input.parentNode.parentNode.children[ 0 ].value !== '' &&
          !label.classList.contains( 'label--valid' )) {
          label.classList.add( 'label--valid' );
          label.style.zIndex = 3;
        } else if ( input.classList.contains( 'form-item-select--replace--active' ) &&
          !label.classList.contains( 'label--valid' )) {
          label.classList.add( 'label--valid' );
          label.style.zIndex = 3;
        } else if ( input.classList.contains( 'form-item-select--replace--active' ) &&
          label.classList.contains( 'label--valid' )) {
          label.style.zIndex = 3;
        } else if ( input.parentNode.parentNode.children[ 0 ].value === '' ) {
          label.classList.remove( 'label--valid' );
          label.style.zIndex = 1;
        } else if ( input.parentNode.parentNode.children[ 0 ].value !== '' ) {
          label.style.zIndex = 1;
        }

      });

      input.onfocus = function() {
        document.onkeypress = function( e ) {
          if ( e.keyCode === 32 || e.keyCode === 13 ) {
            input.click();
          }
        };
      };

      [ ...buttons ].forEach(( button, index ) => {
        button.addEventListener( 'click', function() {
          let jobForm = document.getElementById( 'views-exposed-form-jobs-page-jobs' );
          let firstOption = input.parentNode.parentNode.children[ 0 ].children[ 0 ];
          let originInput = input.parentNode.parentNode.children[ 0 ].children[ index ];

          if ( firstOption.value === '' ) {
            originInput = input.parentNode.parentNode.children[ 0 ].children[ index + 1 ];
          }

          input.parentNode.parentNode.children[ 0 ].value = originInput.value;
          if ( typeof ( Event ) === 'function' ) {
            input.parentNode.parentNode.children[ 0 ].dispatchEvent( new Event( 'change' ));
          } else {
            let event = document.createEvent( 'Event' );
            event.initEvent( 'change', true, true );
            input.parentNode.parentNode.children[ 0 ].dispatchEvent( event );
          }

          if ( jobForm !== null ) {
            jobForm.submit();
          }
          input.click();
          if ( input.parentNode.parentNode.children[ 0 ].classList.contains( 'form-select--invalid' )) {
            input.parentNode.parentNode.children[ 0 ].classList.remove( 'form-select--invalid' );
            let valid = this.checkForInvalid();
            if ( valid === null ) {
              if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
                this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
              }
            }
          }
        }.bind( this ));

        button.onfocus = function() {
          document.onkeypress = function( e ) {
            if ( e.keyCode === 32 || e.keyCode === 13 ) {
              button.click();
            }
          }.bind( this );
        }.bind( this );
      });
    }.bind( this ));
  }
  handleInput() {
    this.disableSelect();

    window.addEventListener( 'resize', () => {
      this.disableSelect();
    });

    this.inputTexts.forEach( function( input ) {
      input.onchange = () => {
        this.handleLabel( input );
      };

      input.addEventListener( 'invalid', ( e ) => {
        e.preventDefault();
      });

      input.addEventListener( 'input', function() {
        if ( input.id === 'edit-iban' && !IBAN.isValid( input.value ) && !input.classList.contains( 'form-iban--invalid' )) {
          input.classList.add( 'form-iban--invalid' );
          input.parentNode.classList.add( 'js-form-item--invalid' );
        } else if ( input.id === 'edit-iban' && IBAN.isValid( input.value ) && input.classList.contains( 'form-iban--invalid' )) {
          input.classList.remove( 'form-iban--invalid' );
          input.parentNode.classList.remove( 'js-form-item--invalid' );
        } else if ( input.id === 'edit-bic' && !BIC.isValid( input.value ) && !input.classList.contains( 'form-bic--invalid' )) {
          input.classList.add( 'form-bic--invalid' );
          input.parentNode.classList.add( 'js-form-item--invalid' );
        } else if ( input.id === 'edit-bic' && BIC.isValid( input.value ) && input.classList.contains( 'form-bic--invalid' )) {
          input.classList.remove( 'form-bic--invalid' );
          input.parentNode.classList.remove( 'js-form-item--invalid' );
        } else if (input.classList.contains( 'label--valid' ) && input.classList.contains('form-date')) {
          input.parentNode.parentNode.parentNode.classList.remove('js-form-item--invalid');
        }

        if ( input.validity.valid && input.classList.contains( 'form-text--invalid' ) && !input.validity.rangeUnderflow ) {
          input.classList.remove( 'form-text--invalid' );
          input.parentNode.classList.remove( 'js-form-item--invalid' );
          if ( input.classList.contains( 'form-text--invalid-pattern' )) {
            input.classList.remove( 'form-text--invalid-pattern' );
            input.parentNode.classList.remove( 'js-form-item--invalid' );
          }
          let valid = this.checkForInvalid();
          if ( valid === null ) {
            if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
              this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
            }
          }
        } else if ( input.validity.rangeUnderflow ) {
          input.parentNode.classList.add( 'js-form-item--invalid' );
          input.classList.add( 'form-text--invalid' );
          input.classList.add( 'form-text--invalid-pattern' );
        }
      }.bind( this ));
    }.bind( this ));

    this.inputDate.forEach( function( input ) {
      input.addEventListener( 'change', function() {
        // Then trigger the input event
        input.dispatchEvent(new Event('input'));

        if (input.classList.contains('label--valid') && input.classList.contains('form-date')) {
          input.parentNode.parentNode.parentNode.classList.remove('js-form-item--invalid');
        }
      }.bind( this ));

    }.bind( this ));

    this.textareas.forEach( function( input ) {

      input.onfocus = () => {
        input.parentNode.classList.add( 'js-form-type-textarea--focus' );
      };

      input.addEventListener( 'invalid', ( e ) => {
        e.preventDefault();
      });

      input.onblur = () => {
        if ( input.parentNode.classList.contains( 'js-form-type-textarea--focus' )) {
          input.parentNode.classList.remove( 'js-form-type-textarea--focus' );
        }
      };

      input.onchange = () => {
        if ( input.value.trim() !== '' ) {
          input.parentNode.children[ 1 ].classList.add( 'label--valid' );
        } else if ( input.value.trim() === '' && input.parentNode.children[ 1 ].classList.contains( 'label--valid' )) {
          input.parentNode.children[ 1 ].classList.remove( 'label--valid' );
          let valid = this.checkForInvalid();
          if ( valid === null ) {
            if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
              this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
            }
          }
        }
      };

      input.addEventListener( 'input', function() {

        if ( input.validity.valid && input.classList.contains( 'form-textarea--invalid' )) {
          input.classList.remove( 'form-textarea--invalid' );
          input.parentNode.classList.remove( 'js-form-item--invalid' );
          let valid = this.checkForInvalid();
          if ( valid === null ) {
            if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
              this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
            }
          }
        }
      }.bind( this ));
    }.bind( this ));

    this.checkBoxes.forEach( function( input ) {
      input.onchange = function() {
        if ( input.validity.valid && input.classList.contains( 'form-checkbox--invalid' )) {
          input.classList.remove( 'form-checkbox--invalid' );
          input.parentNode.classList.remove( 'js-form-item--invalid' );
          let valid = this.checkForInvalid();
          if ( valid === null ) {
            if ( this.node.querySelector( '.form__general-error-wrapper--show' )) {
              this.node.querySelector( '.form__general-error-wrapper' ).classList.remove( 'form__general-error-wrapper--show' );
            }
          }
        }
      }.bind( this );

      input.addEventListener( 'invalid', ( e ) => {
        e.preventDefault();
      });
    }.bind( this ));

    // Iterate over each input radio element
    this.inputRadio.forEach(function(input) {
      input.onchange = function() {
        // Find the closest .radios--wrapper to the current input radio element
        let radioContainer = input.closest('.radios--wrapper');

        if (radioContainer && input.validity.valid && radioContainer.classList.contains('form-radio--invalid')) {
          radioContainer.classList.remove('form-radio--invalid');
          input.parentNode.classList.remove('js-form-item--invalid');
          let valid = this.checkForInvalid();
          if (valid === null) {
            // Find the .form__general-error-wrapper inside the current input's parent node
            let generalErrorWrapper = input.closest('.js-form-item').querySelector('.form__general-error-wrapper--show');
            if (generalErrorWrapper) {
              generalErrorWrapper.classList.remove('form__general-error-wrapper--show');
            }
          }
        }
      }.bind( this );

      input.addEventListener( 'invalid', ( e ) => {
        e.preventDefault();
      });
    }.bind( this ));

    if ( this.submit ) {

      this.submit.addEventListener( 'click', function( e ) {
        this.inputSelect.forEach( function( input ) {
          if ( input.classList.contains( 'required' ) && input.value === '' ) {
            input.classList.add( 'form-select--invalid' );
            input.parentNode.classList.add( 'js-form-item--invalid' );
          }
        });

        this.inputDate.forEach( function( input ) {
          if ( input.classList.contains( 'required' ) && input.value === '' ) {
            input.classList.add( 'form-text--invalid' );
            input.parentNode.parentNode.parentNode.classList.add( 'js-form-item--invalid' );
          }
        });

        if (this.inputRadio.length > 0) {
          // Iterate over each radio wrapper
          for (let i = 0; i < this.inputRadio.length; i++) {
            let radioWrapper = this.inputRadio[i].closest('.radios--wrapper');

            // Skip the loop iteration if radioWrapper is empty
            if (!radioWrapper) {
              continue;
            }

            // Find all radio buttons within the current wrapper
            let radioButtons = radioWrapper.querySelectorAll('.form-radio');

            // Check if any radio button within the group is checked
            let set = false;
            for (let j = 0; j < radioButtons.length; j++) {
              let input = radioButtons[j];
              if (input.checked) {
                set = true;
                break;
              }
            }

            // If none of the radio buttons in the group are checked
            if (!set) {
              // Add the 'form-radio--invalid' class to the radioContainer and its parent node
              if (radioWrapper && !radioWrapper.classList.contains('form-radio--invalid')) {
                radioWrapper.classList.add('form-radio--invalid');
                radioWrapper.parentNode.classList.add('js-form-item--invalid');
              }
              // Update 'valid' if needed
              if (valid !== null) {
                valid = radioWrapper;
              }
            } else {
              // Remove the 'form-radio--invalid' class from the radioContainer and its parent node
              if (radioWrapper && radioWrapper.classList.contains('form-radio--invalid')) {
                radioWrapper.classList.remove('form-radio--invalid');
                radioWrapper.parentNode.classList.remove('js-form-item--invalid');
              }
            }
          }
        }

        let valid = this.checkForInvalid();

        if ( document.querySelector( '.form-iban--invalid' )) {
          document.querySelector( '.form-iban--invalid' ).classList.add( 'form-text--invalid' );
          document.querySelector( '.form-iban--invalid' ).classList.add( 'form-text--invalid-pattern' );
          e.preventDefault();
          if ( valid !== null ) {
            valid = document.querySelector( '.form-iban--invalid' );
          }
        }
        if ( document.querySelector( '.form-bic--invalid' )) {
          document.querySelector( '.form-bic--invalid' ).classList.add( 'form-text--invalid' );
          document.querySelector( '.form-bic--invalid' ).classList.add( 'form-text--invalid-pattern' );
          e.preventDefault();
          if ( valid !== null ) {
            valid = document.querySelector( '.form-bic--invalid' );
          }
        }

        if ( this.uploads.length > 0 ) {
          this.uploads.forEach( function( upload ) {
            let button = upload.querySelector( '.js-form-file' );
            let uploadRequired = upload.querySelector( '.form-required' );
            if ( uploadRequired !== null && button.value === '' ) {
              upload.classList.add( 'js-form-type-webform-document-file--invalid' );
              if ( valid === null ) {
                valid = upload;
              }
            }
          });
        }

        if ( valid !== null ) {
          e.preventDefault();
          if ( this.node.querySelector( '.form__general-error-wrapper' ) && !this.node.querySelector( '.form__general-error-wrapper--show' )) {
            this.node.querySelector( '.form__general-error-wrapper' ).classList.add( 'form__general-error-wrapper--show' );
          }

          let field = valid.getBoundingClientRect().top;
          let bodyPos = document.body.getBoundingClientRect().top;
          let headerHeight = document.querySelector( '.header' ).offsetHeight;
          let toScroll = ( field - bodyPos ) - headerHeight;

          window.scrollTo({ top: toScroll, behavior: 'smooth' });
        } else {
          e.stopImmediatePropagation();
          this.node.querySelector( 'FORM' ).submit();
          this.submit.disabled = true;
        }
      }.bind( this ));
    }


    this.tooltips.forEach( function( tooltip ) {
      tooltip.addEventListener( 'click', () => {
        tooltip.classList.toggle( 'webform-element-help--open' );
        if ( tooltip.classList.contains( 'webform-element-help--open' )) {
          setTimeout(() => {
            tooltip.children[ 1 ].style.height = 'auto';
          }, 300 );
        } else {
          tooltip.children[ 1 ].style.height = 1.625 + 'rem';
        }
      });
    });

    this.uploads.forEach( function( upload ) {
      let button = upload.querySelector( '.js-form-file' );
      let fakeButton = upload.querySelector( '.form-file__browse' );
      let nameField = upload.querySelector( '.form-file__filename' );
      let nameFieldValue = nameField.innerHTML;
      let uploadRequired = upload.querySelector( '.form-required' );

      fakeButton.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        if ( button ) {
          button.click();
          e.stopPropagation();
        }
      });

      if ( button ) {
        button.addEventListener( 'change', () => {
          let size = button.files[ 0 ].size / 1000 / 1000;
          if ( size > 10 ) {
            button.value = null;
            button.innerHTML = nameFieldValue;
          } else {
            let temp = button.value.split( '\\' );
            let name = temp[ temp.length - 1 ];

            if ( name.length >= 30 ) {
              let fileArray = name.split( '.' );
              let file = fileArray[ fileArray.length - 1 ];
              name = name.substring( 0, 25 - file.length );
              name = name + '...' + file;
            }
            nameField.innerHTML = name;
            if ( upload.classList.contains( 'js-form-type-webform-document-file--invalid' )) {
              upload.classList.remove( 'js-form-type-webform-document-file--invalid' );
            }
          }
        });
      }
    });
  }
  checkForInvalid() {
    let fields = this.node.querySelectorAll( '.js-form-item' );

    for ( let input of fields ) {
      if (input.classList.contains('js-webform-states-hidden')) {
        let computedStyle = window.getComputedStyle(input);
        // Check if the input element is visible
        if (computedStyle.visibility === 'hidden' || computedStyle.display === 'none' || computedStyle.opacity === '0') {
          continue;
        }
      }

      if ( input && !input.classList.contains( 'form-no-label' )) {
        if ( input.children[ 0 ].type === 'number' && input.children[ 0 ].classList.contains( 'form-text--invalid' )) {
          input.children[ 0 ].classList.remove( 'form-text--invalid' );
          input.classList.add( 'js-form-item--invalid' );
        } else if ( input.children[ 0 ].type === 'email' && input.children[ 0 ].classList.contains( 'form-text--invalid' )) {
          input.children[ 0 ].classList.remove( 'form-text--invalid' );
          input.classList.add( 'js-form-item--invalid' );
        }
        if ( input.children[ 0 ].classList.contains( 'form-text--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-textarea--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-checkbox--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-select--invalid' )) {
          // do nothing
        } else if ( input.children[ 0 ].classList.contains( 'required' )) {
          if ( input.children[ 0 ].type === 'text' ) {
            if ( input.children[ 0 ].validity.valueMissing ) {
              input.children[ 0 ].classList.add( 'form-text--invalid' );
              input.classList.add( 'js-form-item--invalid' );
            } else if ( input.children[ 0 ].validity.typeMismatch ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid-pattern' );
            }
          } else if ( input.children[ 0 ].type === 'number' ) {
            if ( input.children[ 0 ].validity.valueMissing ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid' );
            } else if ( input.children[ 0 ].validity.rangeUnderflow ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid-pattern' );
            }
          } else if ( input.children[ 0 ].type === 'email' ) {
            if ( input.children[ 0 ].validity.valueMissing ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid' );
            } else if ( input.children[ 0 ].validity.typeMismatch ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid' );
              input.children[ 0 ].classList.add( 'form-text--invalid-pattern' );
            }
          } else if ( input.children[ 0 ].type === 'textarea' && ( input.children[ 0 ].value === '' || input.children[ 0 ].value === null || input.children[ 0 ].value === undefined )) {
            input.classList.add( 'js-form-item--invalid' );
            input.children[ 0 ].classList.add( 'form-textarea--invalid' );
          } else if ( input.children[ 0 ].classList.contains( 'required' ) && input.children[ 0 ].type === 'checkbox' ) {
            if ( !input.children[ 0 ].checked ) {
              input.classList.add( 'js-form-item--invalid' );
              input.children[ 0 ].classList.add( 'form-checkbox--invalid' );
            }
          }
        }
      }
    }

    for ( let input of fields ) {
      if ( !input.classList.contains( 'form-no-label' )) {
        if ( input.children[ 0 ].classList.contains( 'form-text--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-textarea--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-checkbox--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-iban--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-bic--invalid' ) ||
          input.children[ 0 ].classList.contains( 'form-select--invalid' )) {

          return input;
        }

        let radioContainer = input.closest('.radios--wrapper');
        if (radioContainer && radioContainer.classList.contains('form-radio--invalid')) {
          return input;
        }

        if (
          input.classList.contains( 'js-form-type-datetime' ) &&
          input.querySelector('.form-date.required:not(.label--valid)')
        ) {
          if (input.classList.contains('js-webform-states-hidden')) {
            let computedStyle = window.getComputedStyle(input);
            // Check if the input element is visible
            if (computedStyle.visibility === 'hidden' || computedStyle.display === 'none' || computedStyle.opacity === '0') {

            } else {
              return input;
            }
          }
        }
      }
    }
    return null;
  }
  disableSelect() {
    if ( window.innerWidth >= 1024 ) {
      this.inputSelect.forEach( function( input ) {
        if ( !input.classList.contains( 'form-select--disabled' )) {
          input.classList.add( 'form-select--disabled' );
        }
      });
    } else {
      this.inputSelect.forEach( function( input ) {
        if ( input.classList.contains( 'form-select--disabled' )) {
          input.classList.remove( 'form-select--disabled' );
        }
      });
    }
  }
  handleLabel( input ) {
    if ( input.value.trim() !== '' ) {
      input.parentNode.children[ 1 ].classList.add( 'label--valid' );
    } else if ( input.value.trim() === '' && input.parentNode.children[ 1 ].classList.contains( 'label--valid' )) {
      input.parentNode.children[ 1 ].classList.remove( 'label--valid' );
    }
  }
  handleNewSelectFields() {
    this.node.arrive( '.js-form-type-select', function( input ) {
      this.inputSelect = this.node.querySelectorAll( '.form-select' );
      this.handleSelectInput( input.querySelectorAll( '.form-select' ), input.querySelectorAll( '.form-item-select--replace' ));
    }.bind( this ));
  }
}
